import { render, staticRenderFns } from "./recordDetail.vue?vue&type=template&id=13f8f582&scoped=true"
import script from "./recordDetail.vue?vue&type=script&lang=js"
export * from "./recordDetail.vue?vue&type=script&lang=js"
import style0 from "./recordDetail.vue?vue&type=style&index=0&id=13f8f582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f8f582",
  null
  
)

export default component.exports